import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	changeDateMessage: {
		id: 'townsquare.date-range-picker.change-date-message',
		defaultMessage:
			"Generally, it's not the best practice to change the target date of a goal once it has been scored. If you do change this date, consider explaining why in your next update.",
		description: 'Warning message shown when changing the target date of a goal',
	},
	changeDateTooltipTitle: {
		id: 'townsquare.date-range-picker.change-date-tooltip-title',
		defaultMessage: 'Changing the target date?',
		description: 'Tooltip title shown when changing the target date of a goal',
	},
	confirmButton: {
		id: 'townsquare.date-range-picker.confirmation.confirm',
		defaultMessage: 'Confirm',
		description: 'Confirm button label for the date range picker confirmation step',
	},
	cancelButton: {
		id: 'townsquare.date-range-picker.confirmation.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button label for the date range picker confirmation step',
	},
});
